// extracted by mini-css-extract-plugin
export default {"wrapButtonFooter":"edit-quotation_wrapButtonFooter__7l3IT"};